import axios from 'axios';

export const getReportByType = (type, fetch) => {
  return axios.post('admin-report/', {
    type,
    fetch,
  });
};

export const getWeakness = (type) => axios.get(`weakness${type ? `?type=${type}` : ''}`);
